(function () {
  var FADE_DURATION = 3000;
  var STAGGER_DELAY = 100;

  var MOBILE_QUERY = (window.FoxTheme && FoxTheme.config && FoxTheme.config.mediaQueryMobile) || '(max-width: 767px)';

  function initRotator(grid) {
    if (window.matchMedia(MOBILE_QUERY).matches) return;

    var visibleCount = parseInt(grid.dataset.rotateVisible, 10) || 0;
    if (!visibleCount) return;

    var interval = parseInt(grid.dataset.rotateInterval, 10) || 8000;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.f-column'));
    if (items.length <= visibleCount) return;

    var visible = items.slice(0, visibleCount);
    var queue = items.slice(visibleCount);
    var transitionValue = 'opacity ' + FADE_DURATION / 1000 + 's ease';

    function swapColumn(outgoingItem, incomingItem) {
      outgoingItem.style.transition = transitionValue;
      outgoingItem.classList.add('rotate-fade');

      window.setTimeout(function () {
        outgoingItem.parentNode.insertBefore(incomingItem, outgoingItem);
        outgoingItem.classList.add('is-rotate-hidden');
        outgoingItem.classList.remove('rotate-fade');
        outgoingItem.style.transition = '';

        incomingItem.style.transition = transitionValue;
        incomingItem.classList.remove('is-rotate-hidden');
        incomingItem.classList.add('rotate-fade');

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            incomingItem.classList.remove('rotate-fade');
            window.setTimeout(function () {
              incomingItem.style.transition = '';
            }, FADE_DURATION);
          });
        });
      }, FADE_DURATION);
    }

    function swapAll() {
      if (queue.length === 0) return;

      visible.forEach(function (outgoingItem, idx) {
        var incomingItem = queue.shift();
        if (!incomingItem) return;
        queue.push(outgoingItem);
        visible[idx] = incomingItem;

        window.setTimeout(function () {
          swapColumn(outgoingItem, incomingItem);
        }, idx * STAGGER_DELAY);
      });
    }

    window.setInterval(swapAll, interval);
  }

  document.querySelectorAll('[data-rotate-visible]').forEach(initRotator);
})();
